import React, { useState, useEffect, useRef } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import {
    Box, Paper,
    Typography,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Chip,
    LinearProgress,
    Tabs,
    Tab,
    TextField,
    Avatar,
    Button,
    Divider,
    IconButton,
    Tooltip,
    Menu, Stack,
    MenuItem, Grid, TableHead, TableContainer, Snackbar, Alert,
    Modal, Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import {
    Code, Flag, CheckCircle, StackedBarChart, AssignmentInd, Person, People, CheckCircle as CheckCircleIcon,
    Business, Close as CloseIcon,
    Subject as SubjectIcon,
    Person as PersonIcon,
    PlaylistAddCheck as PlaylistAddCheckIcon,
    Timeline as TimelineIcon,
    CalendarToday as CalendarTodayIcon,
    Comment as CommentIcon,
    Add as AddIcon,
    Visibility as VisibilityIcon,
    AccessTime as AccessTimeIcon,
    AttachFile as AttachFileIcon,
    Description as DescriptionIcon,
    Lock as LockIcon,
    Delete as DeleteIcon,
    TaskAlt, Subject, Comment,
    ArrowDropDown, AccountCircle, Edit as EditIcon, AccessAlarm, AccessTimeFilled
} from '@mui/icons-material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ImageIcon from '@mui/icons-material/Image';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { styled } from '@mui/material/styles';
import { axiosInstance, localAxiosToken, localAxiosGet, localAxiosFileUpload, localAxiosDelete } from '../Axios/axios';
import axios from 'axios';
import Back from '../assets/Back.png';
import { EditNote as EditTaskIcon } from '@mui/icons-material';
import EditTaskDetails from '../pages/Manager/Tasks/EditTaskDetails';
import moment from 'moment';
import { Loader } from './loade';
import { UploadCloudIcon } from 'lucide-react';

const statusColors = {
    'Open': 'info',
    'In Progress': 'primary',
    'Submit For Review': 'warning',
    'Completed': 'success',
    'Re Open': 'secondary',
    'Hold': 'default',
    'Overdue': 'error',
    'default': 'default'
};

const statusTextColors = {
    'Open': '#ffffff',
    'In Progress': '#ffffff',
    'Submit For Review': '#ffffff',
    'Completed': '#ffffff',
    'Re Open': '#ffffff',
    'Hold': '#757575',
    'Overdue': '#ffffff',
    'default': '#757575',
};



const priorityColors = {
    'High': 'error',
    'Medium': 'warning',
    'Low': 'success',
    'default': 'default',
};

const priorityTextColors = {
    'High': '#ffffff',
    'Medium': '#ffffff',
    'Low': '#ffffff',
    'default': '#757575',
};

const stripedRowColors = {
    odd: '#f0f0f0',
    even: '#fff',
};
const StripedTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '& *': {
        padding: theme.spacing(1),
    },
}));

const formatTime = (hoursDecimal) => {
    if (hoursDecimal === null || hoursDecimal === undefined || hoursDecimal === '') {
        return '--:--';
    }

    // Convert decimal hours to total minutes
    const totalMinutes = hoursDecimal * 60;
    let hours = Math.floor(totalMinutes / 60);
    let minutes = Math.round(totalMinutes % 60);

    // Handle case where minutes round up to 60
    if (minutes === 60) {
        hours += 1;
        minutes = 0;
    }

    return `${hours} hrs ${minutes.toString().padStart(2, '0')} mins`;
}

const TaskDetails = ({ onClose, taskId, onTaskDeleted }) => {
    const [value, setValue] = useState(0);
    const [taskDetails, setTaskDetails] = useState({});
    const [statusAnchorEl, setStatusAnchorEl] = useState(null);
    const [priorityAnchorEl, setPriorityAnchorEl] = useState(null);
    const [updatedTaskDetails, setUpdatedTaskDetails] = useState({
        progress: '',
        status: '',
        priority: '',
        comment: '',
        submit_for_review: false,
        actual_time: '',
    });

    const [selectedSubTaskId, setSelectedSubTaskId] = useState(null);
    const [isEditTaskDetailsOpen, setIsEditTaskDetailsOpen] = useState(false);
    const [viewingSubTask, setViewingSubTask] = useState(false);
    const [selectedTask, setSelectedTask] = useState({})

    const [editedDetails, setEditedDetails] = useState({})

    const [userDetails, setUserDetails] = useState('');
    //console.log('userdetails', userDetails)
    const [isManager, setIsManager] = useState(false);
    const [taskComments, setTaskComments] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('error');
    const accessToken = localStorage.getItem('accessToken');

    // 1. Add missing state variables after existing useState declarations
    const [openEditModal, setOpenEditModal] = useState(false);
    const [actualTimeEdit, setActualTimeEdit] = useState({
        hours: '',
        minutes: ''
    });
    const [minutesError, setMinutesError] = useState(false);

    const [attachments, setAttachments] = useState([]);
    const [openPreview, setOpenPreview] = useState(false);
    const [previewFile, setPreviewFile] = useState(null);
    const [taskApiMessage, setTaskApiMessage] = useState('')
    const [uploadedFiles, setUploadedFiles] = useState([]);
    // const [uploadedFile, setUploadedFile] = useState(null);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [taskToDelete, setTaskToDelete] = useState(null);
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (updatedTaskDetails.status === 'Completed') {
            setUpdatedTaskDetails({
                progress: 100,
                status: 'Completed'
            })
        }
    }, [updatedTaskDetails.status])

    useEffect(() => {
        const storedUserDetails = localStorage.getItem('userDetails');
        if (storedUserDetails) {
            try {
                const parsedUserDetails = JSON.parse(storedUserDetails);
                setUserDetails(parsedUserDetails);
                setIsManager(parsedUserDetails.user_type === 'Manager' || parsedUserDetails.user_type === 'Team Lead');
            } catch (error) {
                console.error('Error parsing userDetails from localStorage:', error);
            }
        }
    }, []);

    useEffect(() => {
        if (taskDetails) {
            setUpdatedTaskDetails({
                progress: taskDetails.progress !== undefined ? taskDetails.progress : '',
                status: taskDetails.status || '',
                priority: taskDetails.priority || '',
                comment: '',
                submit_for_review: taskDetails.submit_for_review || false,
                actual_time: taskDetails.actual_time || ''
            });
            setTaskComments(taskDetails.comments || []);
        }
    }, [taskDetails]);

    const openStatusMenu = (event) => {
        setStatusAnchorEl(event.currentTarget);
    };

    const closeStatusMenu = () => {
        setStatusAnchorEl(null);
    };

    const openPriorityMenu = (event) => {
        setPriorityAnchorEl(event.currentTarget);
    };

    const closePriorityMenu = () => {
        setPriorityAnchorEl(null);
    };

    useEffect(() => {

        if (taskId) {
            fetchTaskDetails();

        }
    }, [taskId]);

    const fetchTaskDetails = async () => {
        try {
            const response = await axiosInstance(localAxiosGet(`/task/getManagerTaskById?task_id=${taskId}`, accessToken));
            if (response.data.status === 'SUCCESS') {
                console.log('task details', response.data);
                setTaskDetails(response.data.message.task);
            }
        } catch (error) {
            console.log('Error in fetching the task details', error);
        }
    };



    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleSubTaskDetails = (subTaskId) => {
        setSelectedSubTaskId(subTaskId);
        setViewingSubTask(true);
    };

    // Add this function to format status text
    const formatStatusText = (status) => {
        if (!status) return 'Not Set';

        return status
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    };
    const handleBackFromSubTask = () => {
        setViewingSubTask(false);
        setSelectedSubTaskId(null);
    };

    const handleEditTaskDetails = (task) => {
        console.log('Editing task ID:', task);
        setIsEditTaskDetailsOpen(true);
        setSelectedTask(task)
    }

    const handleEditTaskPopupClose = () => {
        fetchTaskDetails();
        setIsEditTaskDetailsOpen(false)
    }

    function capitalizeFirstChar(str) {
        if (!str) {
            return "";
        }
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    // 2. Add missing functions before the return statement

    const handleOpenEditModal = () => {
        // Parse existing actual_hours to populate the modal
        const existingTime = updatedTaskDetails.actual_time || taskDetails.actual_hours || '';
        if (existingTime) {
            const parts = String(existingTime).split('.');
            setActualTimeEdit({
                hours: parts[0] || '',
                minutes: parts[1] || ''
            });
        } else {
            setActualTimeEdit({ hours: '', minutes: '' });
        }
        setMinutesError(false);
        setOpenEditModal(true);
    };

    const handleCloseEditModal = () => {
        setOpenEditModal(false);
        setActualTimeEdit({ hours: '', minutes: '' });
        setMinutesError(false);
    };

    const handleActualTimeHoursChange = (e) => {
        const value = e.target.value;
        if (value === '' || (/^\d+$/.test(value) && parseInt(value) >= 0)) {
            setActualTimeEdit(prev => ({ ...prev, hours: value }));
        }
    };

    const handleActualTimeMinutesChange = (e) => {
        const value = e.target.value;
        if (value === '' || (/^\d+$/.test(value))) {
            const numValue = parseInt(value);
            if (value === '' || numValue <= 59) {
                setActualTimeEdit(prev => ({ ...prev, minutes: value }));
                setMinutesError(false);
            } else {
                setMinutesError(true);
            }
        }
    };

    const handleSaveActualTime = () => {
        const { hours, minutes } = actualTimeEdit;

        // Validation
        if (!hours && !minutes) {
            handleCloseEditModal();
            return;
        }

        if (parseInt(minutes) > 59) {
            setMinutesError(true);
            return;
        }

        // Convert minutes to decimal fraction (minutes/60)
        const minutesDecimal = minutes ? parseInt(minutes) / 60 : 0;
        const hoursValue = hours ? parseInt(hours) : 0;

        // Format the time as decimal hours (e.g., 2 hours 30 minutes = 2.5)
        const formattedTime = hoursValue + minutesDecimal;

        // Update the actual_time in updatedTaskDetails
        setUpdatedTaskDetails(prev => ({
            ...prev,
            actual_time: formattedTime
        }));

        handleCloseEditModal();
    };

    const handleSendForReviewButton = async () => {
        setIsLoading(true);
        setTaskApiMessage('');
        if (updatedTaskDetails.actual_time === '') {
            setTaskApiMessage('Please update the Actual time for task')
            setIsLoading(false)
            return
        }

        try {
            // Step 1: Upload attachments if they exist
            if (attachments.length > 0) {
                const formData = new FormData();
                attachments.forEach((attachment) => {
                    formData.append('files', attachment.file);
                });

                const uploadResponse = await axiosInstance(localAxiosFileUpload(`/task/attachmentUpload/${taskId}`, formData, accessToken));

                if (uploadResponse.data?.message?.attachments) {
                    setUploadedFiles(prev => [...prev, ...uploadResponse.data.message.attachments]);
                    setAttachments([]);
                }
            }

            // Step 2: Update task status

            const payload = {
                employee_id: userDetails.id,
                task_id: taskDetails.task_id,
                // status: 'Submit For Review',
                comment: updatedTaskDetails.comment || '',
                submit_for_review: true,
                actual_hours: updatedTaskDetails.actual_time || '', // This is now in decimal format
            };

            await axiosInstance(localAxiosToken('/task/updateTaskStatusByEmployee', payload));

            // Step 3: Refresh task details
            await fetchTaskDetails();

            setTaskApiMessage('Task submitted for review successfully!');
        } catch (error) {
            console.error('Submission failed:', error);
            setTaskApiMessage(
                error.response?.data?.message ||
                error.message ||
                'Failed to submit for review'
            );
        } finally {
            setIsLoading(false);
        }
    };

    const handleSaveUpdateDetailsButton = async () => {
        const payload = {

            employee_id: userDetails.id,
            task_id: taskDetails.task_id,
            status: updatedTaskDetails.status || '',
            comment: updatedTaskDetails.comment || '',
            submit_for_review: false,
            progress: updatedTaskDetails.progress,
            priority: updatedTaskDetails.priority || ''

        }
        try {
            const response = await axiosInstance(localAxiosToken('/task/updateTaskStatusByManager', payload));
            console.log('update details response', response.data)
        } catch (error) {
            console.log('Error in updating the task details', error)
        }

        setIsLoading(true);
        try {
            const response = await axiosInstance(localAxiosGet(`/task/getManagerTaskById?task_id=${taskDetails.task_id}`, accessToken));
            if (response.data && response.data.message && response.data.message.task) {
                const updatedTask = response.data.message.task;
                // Update the single state variable
                setUpdatedTaskDetails({
                    progress: updatedTask.progress !== undefined ? updatedTask.progress : '',
                    status: updatedTask.status || '',
                    priority: updatedTask.priority || '',
                    comment: '' // Clear comment input after saving
                });
                setTaskComments(updatedTask.comments || []);
                setTaskDetails(updatedTask);
                setTaskApiMessage('Task Details are updated successfully!');
            }
        } catch (error) {
            console.error('Submission failed:', error);
            setTaskApiMessage(
                error.response?.data?.message ||
                error.message ||
                'Failed to save the details. Please try again'
            );
        } finally {
            setTimeout(() => {
                setIsLoading(false)
            }, [1000])
        }
    }


    // Handle file upload for mutiple files
    const handleFileUpload = (event) => {
        const files = Array.from(event.target.files);

        const newAttachments = files.map(file => ({
            id: `file-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
            file: file,
            name: file.name,
            type: file.type,
            url: URL.createObjectURL(file)
        }));

        setAttachments([...attachments, ...newAttachments]);
        // Reset file input
        event.target.value = null;
    };

    //Handle file upload for single file
    // const handleFileUpload = (event) => {
    //     const files = Array.from(event.target.files);

    //     if (files.length > 0) {
    //         // Take only the first file if multiple are selected
    //         setAttachemnerFileMessage('')
    //         const file = files[0];

    //         const newAttachment = {
    //             id: `file-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    //             file: file,
    //             name: file.name,
    //             type: file.type,
    //             url: URL.createObjectURL(file)
    //         };

    //         setAttachments([newAttachment]); // Replace any existing attachment
    //     }

    //     // Reset file input
    //     event.target.value = null;
    // };

    // Handle opening file preview
    const handleOpenPreview = (attachment) => {
        console.log('attachemnts', attachments);
        setPreviewFile(attachment);
        setOpenPreview(true);
    };

    // Handle closing file preview
    const handleClosePreview = () => {
        setOpenPreview(false);
        setPreviewFile(null);
    };

    // Handle deleting an attachment
    const handleDeleteAttachment = (id) => {
        const updatedAttachments = attachments.filter(attachment => attachment.id !== id);
        setAttachments(updatedAttachments);
    };

    // const handleUploadAttachmentsButton = async () => {
    //     if (attachments.length === 0) {
    //         setTaskApiMessage('Please add files to upload');
    //         return;
    //     }

    //     try {
    //         const formData = new FormData();

    //         attachments.forEach((attachment) => {
    //             formData.append('files', attachment.file);
    //         });

    //         const response = await axios.post(
    //             `https://hrmsapi.hashstack.in/api/task/attachmentUpload/${taskId}`,
    //             formData,
    //             {
    //                 headers: {
    //                     'Content-Type': 'multipart/form-data',
    //                     'Authorization': `Bearer ${accessToken}`
    //                 }
    //             }
    //         );

    //         if (response.data && response.data.message && response.data.message.attachments) {
    //             setUploadedFiles(prev => [...prev, ...response.data.message.attachments]);
    //             setAttachments([]);
    //             setTaskApiMessage('Files uploaded successfully!');
    //             fetchTaskDetails();
    //         }
    //     } catch (error) {
    //         console.error('Upload failed:', error);
    //         setTaskApiMessage(`Upload failed: ${error.response?.data?.message || error.message}`);
    //     }
    // };

    const handleDeleteClick = (taskId) => {
        setTaskToDelete(taskId);
        setDeleteConfirmOpen(true);
    };

    const handleConfirmDelete = async () => {
        if (!taskToDelete) return;

        try {
            const response = await axiosInstance(localAxiosDelete(`/task/deleteTask/${taskToDelete}`, accessToken));
            if (response.data.status === 'SUCCESS') {
                setSnackbarOpen(true);
                setSnackbarMessage('Successfully Deleted the Task');
                setSnackbarSeverity('success');

                setTimeout(() => {
                    if (onTaskDeleted) {
                        onTaskDeleted();
                    }
                }, 1500);
            } else {
                setSnackbarOpen(true);
                setSnackbarMessage(response.data?.message || response.data?.message?.msg || 'Error while deleting the Task');
                setSnackbarSeverity('error');
            }
        } catch (error) {
            console.error('Error in deleting task', error);
            setSnackbarOpen(true);
            setSnackbarMessage(error.response?.data?.message || 'Error while deleting the Task');
            setSnackbarSeverity('error');
        } finally {
            setDeleteConfirmOpen(false);
            setTaskToDelete(null);
        }
    };

    const handleCancelDelete = () => {
        setDeleteConfirmOpen(false);
        setTaskToDelete(null);
    };

    const UploadedFilesList = () => {
        const [openPreview, setOpenPreview] = useState(false);
        const [previewFile, setPreviewFile] = useState(null);

        // Combine both uploadedFiles and task attachments
        const allFiles = [
            ...(taskDetails.attachments?.map(attachment => ({
                url: attachment.file_url,
                name: attachment.file_name,
                type: attachment.file_name?.match(/\.(jpeg|jpg|png|gif)$/i) ? 'image' :
                    attachment.file_name?.endsWith('.pdf') ? 'pdf' : 'file'
            })) || [])
        ];

        if (allFiles.length === 0) return null;

        const isImageFile = (filename) => {
            return filename?.match(/\.(jpeg|jpg|png|gif)$/i);
        };

        const handleOpenPreview = (file) => {
            setPreviewFile(file);
            if (isImageFile(file.name)) {
                setOpenPreview(true);
            } else {
                window.open(file.url, '_blank', 'noopener,noreferrer');
            }
        };

        const handleClosePreview = () => setOpenPreview(false);

        const handleDownload = async (file) => {
            try {
                if (!file.url) return;

                // Fallback solution - works for most cases
                const link = document.createElement('a');
                link.href = file.url;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } catch (error) {
                console.error('Download failed:', error);
                window.open(file.url, '_blank');
            }
        };


        return (
            <>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        backgroundColor: 'rgba(100, 181, 246, 0.1)',
                        padding: '8px',
                        borderBottom: '1px solid #ccc',
                    }}
                >
                    <CloudUploadIcon color="primary" />
                    <Typography variant="subtitle2" color="primary" fontWeight={600}>
                        Uploaded files ({allFiles.length})
                    </Typography>
                </Box>

                <TableContainer component={Paper} elevation={2}>
                    <Table size="small">
                        <TableBody>
                            {allFiles.map((file, index) => (
                                <TableRow key={`${file.name}-${index}`}>
                                    <TableCell sx={{ width: 40 }}>
                                        {isImageFile(file.name) ? (
                                            <ImageIcon color="primary" />
                                        ) : file.name.endsWith('.pdf') ? (
                                            <PictureAsPdfIcon color="error" />
                                        ) : (
                                            <InsertDriveFileIcon color="action" />
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2" noWrap sx={{ maxWidth: 300 }}>
                                            {file.name}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="right" sx={{ width: 120 }}>
                                        <Box sx={{ display: 'flex', gap: 1 }}>
                                            <Tooltip title="Preview">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleOpenPreview(file)}
                                                    color="primary"
                                                >
                                                    <VisibilityIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Download">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleDownload(file)}
                                                    color="primary"
                                                >
                                                    <CloudDownloadIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            {/* {!isManager && index < uploadedFiles.length && (
                                                <Tooltip title="Remove">
                                                    <IconButton
                                                        size="small"
                                                        color="error"
                                                        onClick={() => {
                                                            const updated = [...uploadedFiles];
                                                            updated.splice(index, 1);
                                                            setUploadedFiles(updated);
                                                        }}
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            )} */}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* Image Preview Dialog */}
                {openPreview && previewFile && isImageFile(previewFile.name) && (
                    <Dialog
                        open={openPreview}
                        onClose={handleClosePreview}
                        maxWidth="md"
                        fullWidth
                    >
                        <DialogTitle>{previewFile.name}</DialogTitle>
                        <DialogContent sx={{ textAlign: 'center' }}>
                            <img
                                src={previewFile.url}
                                alt={previewFile.name}
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '70vh',
                                    objectFit: 'contain'
                                }}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                startIcon={<CloudDownloadIcon />}
                                onClick={() => handleDownload(previewFile)}
                                variant='contained'
                            >
                                Download
                            </Button>
                            <Button variant='outlined' onClick={handleClosePreview}>Close</Button>
                        </DialogActions>
                    </Dialog>
                )}
            </>
        );
    };

    // Usage in your component:
    // <UploadedFileDisplay taskDetails={taskDetails} setTaskDetails={setTaskDetails} />
    // Render appropriate icon based on file type
    const renderFileIcon = (fileType) => {
        if (fileType.startsWith('image/')) {
            return <ImageIcon />;
        } else if (fileType === 'application/pdf') {
            return < PictureAsPdfIcon />;
        } else {
            return <InsertDriveFileIcon />;
        }
    };

    if (viewingSubTask && selectedSubTaskId) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', bgcolor: '#f0f4f8', borderRadius: '12px' }}>
                <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', p: 2 }}>
                    <img
                        src={Back}
                        alt="Back"
                        style={{
                            width: '24px',
                            height: '24px',
                            cursor: 'pointer',
                            transition: 'transform 0.3s ease'
                        }}
                        onClick={handleBackFromSubTask}
                    />
                    <Typography variant="subtitle1" sx={{ ml: 2, fontWeight: 'medium' }}>
                        Back to Main Task
                    </Typography>
                </Box>
                <TaskDetails onClose={handleBackFromSubTask} taskId={selectedSubTaskId} />
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', bgcolor: '#f0f4f8', borderRadius: '12px' }}>
            {isLoading && <Loader />}
            <Box sx={{ flexGrow: 1, overflow: 'auto', borderRadius: '12px', p: 2 }}>


                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    borderRadius: '12px',
                    bgcolor: 'white'
                }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                        p: 2,
                        borderRadius: '4px',
                        color: 'white',
                        justifyContent: 'space-between',
                        width: '100%'
                    }}>
                        <Typography variant="h5" component="span" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <TaskAlt />
                            Task Details
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', mt: 2, gap: 2 }}>

                    <Box sx={{ p: 3, bgcolor: '#ffffff', flexGrow: 1, display: 'flex' }}>
                        <Box sx={{ flexGrow: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography
                                        variant="h6"
                                        color="primary"
                                        sx={{ fontWeight: 'bold', color: '#2e86de' }}
                                    >
                                        #{taskDetails.task_id}
                                    </Typography>
                                    <Typography variant="h6" sx={{ ml: 1 }}>
                                        {taskDetails.task_title}
                                    </Typography>
                                </Box>

                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                    {taskDetails.submit_for_review && (
                                        <Chip
                                            label={isManager ? "Ready for Review" : "Send for Review"}
                                            size="small"
                                            variant="contained"
                                            sx={{ backgroundColor: '#FFBF00', color: 'white' }}
                                        />
                                    )}
                                    {isManager && (
                                        <Box>

                                            <IconButton aria-label="edit"
                                                size="small"
                                                sx={{ color: 'orange' }}
                                                onClick={() => handleEditTaskDetails(taskDetails)}
                                            >
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton aria-label="delete" size="small" color="error"
                                                onClick={() => handleDeleteClick(taskDetails.task_id)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                            <Box sx={{ mt: 2 }}>
                                <Typography variant="body2" sx={{ color: '#666' }}>
                                    {taskDetails.task_type} Task
                                </Typography>
                            </Box>
                            <Box mt={2} bgcolor="#f8fafc" p={2} borderRadius={1}>
                                <Grid container spacing={2} >
                                    <Grid item xs={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Business sx={{ color: '#1976d2' }} />
                                            <Typography variant="subtitle2" color="textSecondary">
                                                Project Name
                                            </Typography>
                                            <Chip label={taskDetails?.project_name || '-'} size="small" />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <PersonIcon sx={{ color: '#4caf50' }} />
                                            <Typography variant="subtitle2" color="textSecondary">
                                                Created By
                                            </Typography>
                                            <Chip label={`${capitalizeFirstChar(taskDetails?.manager_first_name)} ${capitalizeFirstChar(taskDetails?.manager_last_name)}` || 'N/A'} size="small" />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            {taskDetails?.development_type ? <Code sx={{ color: '#f57c00' }} /> : <AssignmentInd sx={{ color: '#2e7d32' }} />}
                                            <Typography variant="subtitle2" color="textSecondary">
                                                Task Type
                                            </Typography>
                                            <Chip label={`${taskDetails?.task_type || '-'}${taskDetails?.development_type ? ` (${taskDetails.development_type})` : ''}`} size="small" />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <TimelineIcon sx={{ color: '#9c27b0' }} />
                                            <Typography variant="subtitle2" color="textSecondary">
                                                Timeline
                                            </Typography>
                                            <Chip
                                                label={taskDetails?.start_date ? new Date(taskDetails.start_date).toLocaleDateString() : '-'}
                                                size="small"
                                            />
                                            -
                                            <Chip
                                                label={taskDetails?.due_date ? new Date(taskDetails.due_date).toLocaleDateString() : '-'}
                                                size="small"
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <AccessAlarm sx={{ color: '#800080' }} />
                                            <Typography variant="subtitle2" color="textSecondary">
                                                Estimated Time
                                            </Typography>
                                            <Chip label={formatTime(taskDetails?.estimated_hours) || '-'} size="small" />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <AccessTimeFilled sx={{ color: '#2e7d32' }} />
                                            <Typography variant="subtitle2" color="textSecondary">
                                                Actual Time
                                            </Typography>
                                            <Chip
                                                label={formatTime(
                                                    updatedTaskDetails.actual_time || taskDetails?.actual_hours
                                                )}
                                                size="small"
                                            />

                                            {!isManager && (
                                                <IconButton
                                                    aria-label="edit actual time"
                                                    size="small"
                                                    onClick={handleOpenEditModal}
                                                    sx={{ ml: 0.5 }}
                                                >
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    marginBottom: '16px',
                                    mt: 2,
                                    bgcolor: '#f8fafc'
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        backgroundColor: 'rgba(100, 181, 246, 0.1)',
                                        padding: '8px',
                                        borderBottom: '1px solid #ccc',
                                    }}
                                >
                                    <DescriptionIcon color="primary" />
                                    <Typography variant="subtitle2" color="primary" fontWeight={600}>
                                        Description
                                    </Typography>
                                </Box>
                                <Box sx={{ padding: '16px' }}>
                                    <Typography variant="body2" color="text.secondary">
                                        {capitalizeFirstChar(taskDetails?.description) || 'No Description is added'}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    marginBottom: '16px',
                                    mt: 2,
                                    bgcolor: '#f8fafc'
                                }}
                            >

                                <UploadedFilesList />
                            </Box>
                            {/* comments */}
                            {/* <Box
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    marginBottom: '16px',
                                    bgcolor: '#f8fafc'
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        backgroundColor: 'rgba(100, 181, 246, 0.1)',
                                        padding: '8px',
                                        borderBottom: '1px solid #ccc',
                                    }}
                                >
                                    <CommentIcon color="primary" />
                                    <Typography variant="subtitle2" color="primary" fontWeight={600}>
                                        Comments
                                    </Typography>
                                </Box>
                                <Box sx={{ padding: '16px' }}>
                                    <Typography variant="body2" color="text.secondary">
                                        {capitalizeFirstChar(taskDetails?.comment) || 'No comments'}
                                    </Typography>
                                </Box>
                            </Box> */}
                            {taskDetails?.task_type === 'Multiple' && taskDetails?.subtasks && taskDetails?.subtasks.length > 0 && (
                                <Box sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    marginBottom: '16px',
                                    bgcolor: '#f8fafc'
                                }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            backgroundColor: 'rgba(100, 181, 246, 0.1)',
                                            padding: '8px',
                                            borderBottom: '1px solid #ccc',
                                        }}
                                    >
                                        <PlaylistAddCheckIcon color="primary" />
                                        <Typography variant="subtitle2" color="primary" fontWeight={600}>
                                            Sub Tasks
                                        </Typography>
                                    </Box>
                                    <TableContainer>
                                        <Table aria-label="sub tasks">
                                            <TableBody sx={{ '& > tr': { borderBottom: '1px solid rgba(224, 224, 224, 1)' } }}>
                                                {taskDetails.subtasks.map((subTask, index) => (
                                                    <TableRow
                                                        key={subTask.sub_task_id}
                                                        onClick={() => {
                                                            handleSubTaskDetails(subTask.sub_task_id);
                                                        }}
                                                        sx={{
                                                            backgroundColor: index % 2 === 0 ? stripedRowColors.even : stripedRowColors.odd,
                                                            '&:last-child td, &:last-child th': { borderBottom: 0 },
                                                            cursor: 'pointer',
                                                            paddingX: 1,
                                                        }}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            <Typography sx={{ fontWeight: 500 }}>
                                                                {subTask.task_title}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Chip
                                                                label={subTask.status}
                                                                color={statusColors[subTask.status] || 'default'}
                                                                sx={{
                                                                    color: statusTextColors[subTask.status] || statusTextColors.default,
                                                                    fontWeight: 'bold'
                                                                }}
                                                                size="small"
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            {subTask.assignees && subTask.assignees.length > 0 ? (
                                                                subTask.assignees.map((assignee, index) => (
                                                                    <Chip
                                                                        key={index}
                                                                        label={`${capitalizeFirstChar(assignee.first_name)} ${capitalizeFirstChar(assignee.last_name)}`}
                                                                        size="small"
                                                                        sx={{ marginRight: 0.5, marginTop: 0.5 }}
                                                                    />
                                                                ))
                                                            ) : (
                                                                'N/A'
                                                            )}
                                                        </TableCell>
                                                        <TableCell>
                                                            {subTask.submit_for_review}
                                                            <IconButton>
                                                                <CheckCircleIcon style={{ color: subTask.submit_for_review ? '#FFBF00' : 'grey' }} />
                                                            </IconButton>
                                                        </TableCell>
                                                        {/* <TableCell align="right">
                                                            <DeleteIcon color="error" sx={{ cursor: 'pointer' }} />
                                                        </TableCell> */}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            )}

                            <Box sx={{ mt: 4, mb: 2 }}>
                                <Tabs value={value} onChange={handleChange}>
                                    <Tab label={`${taskDetails?.comments?.length || 0} Comments`} />
                                    <Tab label="Activities" />
                                </Tabs>
                                <Box sx={{ mt: 2 }}>
                                    {value === 0 ? (
                                        <Box>
                                            <TextField
                                                fullWidth
                                                placeholder="Type a new comment here"
                                                variant="outlined"
                                                size="small"
                                                value={updatedTaskDetails.comment || ''}
                                                onChange={(e) => setUpdatedTaskDetails(prev => ({ ...prev, comment: e.target.value }))}
                                            />

                                            <Box sx={{ width: '100%', overflow: 'auto', mt: 2 }}>
                                                <Table size="small" aria-label="comments table">
                                                    <TableBody>
                                                        {taskDetails.comments && taskDetails.comments.map((comment) => (
                                                            <StripedTableRow key={comment.id}>
                                                                <TableCell sx={{ fontWeight: 'bold' }}>{capitalizeFirstChar(comment.comment)}</TableCell>
                                                                <TableCell sx={{ width: 50 }}>
                                                                    <Avatar sx={{
                                                                        width: 18, height: 18, fontSize: '0.75rem',
                                                                        backgroundColor: comment.user_type === 'Manager' ? (theme) => theme.palette.primary.main : (theme) => theme.palette.secondary.main,
                                                                        color: comment.user_type === 'Manager' ? (theme) => theme.palette.primary.contrastText : (theme) => theme.palette.secondary.contrastText,
                                                                    }}
                                                                    >
                                                                        {comment.user_type === 'Manager' ? 'M' : 'E'}
                                                                    </Avatar>
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Typography variant="body2" >
                                                                        {capitalizeFirstChar(comment.user?.first_name)} {capitalizeFirstChar(comment.user?.last_name)}
                                                                    </Typography>
                                                                </TableCell>

                                                                <TableCell align="right" sx={{ width: 120 }}>
                                                                    <Typography variant="caption" color="text.secondary">
                                                                        {moment(comment.createdAt).format('YYYY-MM-DD HH:mm')}
                                                                    </Typography>
                                                                </TableCell>
                                                            </StripedTableRow>
                                                        ))}
                                                        {!taskDetails.comments || taskDetails.comments.length === 0 && (
                                                            <TableRow>
                                                                <TableCell colSpan={4} align="center">No comments yet.</TableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <Box sx={{ mt: 1 }}>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    {/* Right Sidebar */}
                    <Box sx={{ ml: 2, width: 400, }}>
                        <Paper sx={{ p: 2, mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 2, mb: 2 }}>
                                <Chip
                                    label={updatedTaskDetails?.status || taskDetails?.status || 'Not Set'}
                                    color={statusColors[updatedTaskDetails?.status || taskDetails?.status] || 'default'}
                                    size="medium"
                                    variant="contained"
                                    sx={{
                                        padding: '4px',
                                        fontWeight: 'bold',
                                        color: statusTextColors[updatedTaskDetails?.status || taskDetails?.status] || statusTextColors.default
                                    }}
                                    onClick={isManager ? openStatusMenu : undefined}
                                />

                                <Menu
                                    anchorEl={statusAnchorEl}
                                    open={Boolean(statusAnchorEl)}
                                    onClose={() => setStatusAnchorEl(null)}
                                >
                                    <MenuItem onClick={() => {
                                        setUpdatedTaskDetails(prev => ({ ...prev, status: 'In Progress' }));
                                        setStatusAnchorEl(null);
                                    }}>In Progress</MenuItem>

                                    <MenuItem onClick={() => {
                                        setUpdatedTaskDetails(prev => ({ ...prev, status: 'Completed' }));
                                        setStatusAnchorEl(null);
                                    }}>Completed</MenuItem>

                                    <MenuItem onClick={() => {
                                        setUpdatedTaskDetails(prev => ({ ...prev, status: 'Re Open' }));
                                        setStatusAnchorEl(null);
                                    }}>Re-open</MenuItem>

                                    <MenuItem onClick={() => {
                                        setUpdatedTaskDetails(prev => ({ ...prev, status: 'Hold' }));
                                        setStatusAnchorEl(null);
                                    }}>Hold</MenuItem>
                                </Menu>
                                <Chip
                                    label={updatedTaskDetails?.priority || taskDetails?.priority || 'Not Set'}
                                    color={priorityColors[updatedTaskDetails?.priority || taskDetails?.priority] || 'default'}
                                    size="medium"
                                    variant="contained"
                                    sx={{ padding: '4px' }}
                                    onClick={isManager ? openPriorityMenu : undefined}

                                >
                                    {updatedTaskDetails?.priority || taskDetails?.priority || 'Not Set'}
                                </Chip>
                                <Menu
                                    anchorEl={priorityAnchorEl}
                                    open={Boolean(priorityAnchorEl)}

                                    onClose={() => setPriorityAnchorEl(null)}
                                >
                                    <MenuItem onClick={() => { closePriorityMenu('High'); setTaskDetails(prev => ({ ...prev, priority: 'High' })); }}>High</MenuItem>
                                    <MenuItem onClick={() => { closePriorityMenu('Medium'); setTaskDetails(prev => ({ ...prev, priority: 'Medium' })); }}>Medium</MenuItem>
                                    <MenuItem onClick={() => { closePriorityMenu('Low'); setTaskDetails(prev => ({ ...prev, priority: 'Low' })); }}>Low</MenuItem>
                                </Menu>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2, bgcolor: '#f8fafc', p: 2, borderRadius: 2 }}>
                                {isManager && (
                                    <TextField
                                        placeholder="0"
                                        fullWidth
                                        inputProps={{ min: 0, max: 100 }}
                                        variant="outlined"
                                        label="Progress Percentage"
                                        type="number"
                                        size="small"
                                        value={updatedTaskDetails.progress !== undefined ? updatedTaskDetails.progress : taskDetails.progress || ''}
                                        onChange={(e) => {
                                            const rawValue = e.target.value;
                                            setUpdatedTaskDetails(prev => ({ ...prev, progress: rawValue }));
                                        }}
                                        onBlur={(e) => {
                                            const value = e.target.value;
                                            if (value === '') {
                                                setUpdatedTaskDetails(prev => ({ ...prev, progress: '' })); // Or null, 0, etc., depending on desired reset
                                            } else {
                                                const parsedValue = parseInt(value, 10);
                                                if (isNaN(parsedValue) || parsedValue < 0 || parsedValue > 100) {
                                                    // Optionally revert to the previous valid value or set an error state
                                                    setUpdatedTaskDetails(prev => ({ ...prev, progress: prev.progress !== undefined ? prev.progress : taskDetails.progress || '' }));
                                                } else {
                                                    setUpdatedTaskDetails(prev => ({ ...prev, progress: parsedValue }));
                                                }
                                            }
                                        }}
                                    />
                                )}
                                <LinearProgress
                                    variant="determinate"
                                    value={parseInt(updatedTaskDetails.progress !== undefined ? updatedTaskDetails.progress : taskDetails.progress || 0)}
                                    sx={{ mt: 1, borderRadius: 4, height: 10 }}
                                />
                                <Box display="flex" justifyContent="space-between" mt={0.5}>
                                    <Typography variant="caption">0%</Typography>
                                    <Typography variant="caption">100%</Typography>
                                </Box>
                            </Box>
                            <Typography variant="body2" sx={{ color: '#666', mb: 1, mt: 2 }}>
                                ASSIGNED TO
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mb: 2, gap: 1 }}>
                                {taskDetails?.assignees?.map((assignee) => (
                                    <Box key={`${assignee.first_name}-${assignee.last_name}`} sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Avatar
                                            sx={{ width: 32, height: 32, bgcolor: '#b48ead' }}
                                        >
                                            {`${assignee.first_name.charAt(0)}`.toUpperCase()}
                                        </Avatar>
                                        <Typography variant="body2" sx={{ ml: 2 }}>
                                            {`${capitalizeFirstChar(assignee.first_name)} ${capitalizeFirstChar(assignee.last_name)}`}
                                        </Typography>
                                    </Box>
                                ))}
                                {taskDetails?.assignees?.length === 0 && (
                                    <Typography variant="body2" color="textSecondary">
                                        Not Assigned
                                    </Typography>
                                )}
                            </Box>
                            {isManager && (
                                <Button
                                    variant="text"
                                    startIcon={<AddIcon />}
                                    sx={{ color: '#2e86de', textTransform: 'none' }}
                                >
                                    Add assigned
                                </Button>
                            )}

                            {/* Attachments section */}
                            {!isManager && (

                                <Box sx={{ mt: 2, mb: 2 }}>
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        Attachments
                                    </Typography>

                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                                        <Button
                                            variant="outlined"
                                            startIcon={<AttachFileIcon />}
                                            onClick={() => fileInputRef.current.click()}
                                            size="small"
                                        >
                                            Add Files
                                        </Button>
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            multiple
                                            onChange={handleFileUpload}
                                            style={{ display: 'none' }}
                                        />
                                        {/* <Button
                                            variant="contained"
                                            size="small"
                                            onClick={handleUploadAttachmentsButton}
                                            startIcon={<CloudUploadIcon />}
                                            disabled={attachments.length === 0}
                                        >
                                            Upload
                                        </Button> */}
                                    </Box>


                                    {/* Files to be uploaded */}
                                    {attachments.length > 0 && (
                                        <Box sx={{ mt: 2 }}>
                                            <Typography variant="caption" color="text.secondary">
                                                Files to be uploaded:
                                            </Typography>
                                            <Grid container spacing={1} sx={{ mt: 1 }}>
                                                {attachments.map((attachment) => {
                                                    // Extract file name and extension
                                                    const lastDotIndex = attachment.name.lastIndexOf('.');
                                                    const fileName = lastDotIndex > 0 ? attachment.name.substring(0, lastDotIndex) : attachment.name;
                                                    const fileExtension = lastDotIndex > 0 ? attachment.name.substring(lastDotIndex) : '';

                                                    return (
                                                        <Grid item key={attachment.id} xs={12}>
                                                            <Paper
                                                                elevation={1}
                                                                sx={{
                                                                    p: 1,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',

                                                                    backgroundColor: 'background.paper',
                                                                    '&:hover': {
                                                                        bgcolor: 'action.hover',
                                                                    }
                                                                }}
                                                            >
                                                                <Box sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    minWidth: 0,
                                                                    flexGrow: 1,
                                                                    pr: 1
                                                                }}>
                                                                    {renderFileIcon(attachment.type)}
                                                                    <Box sx={{
                                                                        ml: 1,
                                                                        minWidth: 0,
                                                                        overflow: 'hidden'
                                                                    }}>
                                                                        <Typography
                                                                            variant="body2"
                                                                            noWrap
                                                                            sx={{
                                                                                display: 'inline'
                                                                            }}
                                                                        >
                                                                            <Box
                                                                                component="span"
                                                                                sx={{
                                                                                    display: 'inline-block',
                                                                                    maxWidth: 'calc(100% - 30px)',
                                                                                    textOverflow: 'ellipsis',
                                                                                    overflow: 'hidden',
                                                                                    whiteSpace: 'nowrap',
                                                                                    verticalAlign: 'bottom'
                                                                                }}
                                                                            >
                                                                                {fileName}
                                                                            </Box>
                                                                            <Box
                                                                                component="span"
                                                                                sx={{
                                                                                    color: 'text.secondary',
                                                                                    ml: 0.5,
                                                                                    flexShrink: 0
                                                                                }}
                                                                            >
                                                                                {fileExtension}
                                                                            </Box>
                                                                        </Typography>
                                                                    </Box>
                                                                </Box>
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleDeleteAttachment(attachment.id);
                                                                    }}
                                                                    sx={{
                                                                        color: 'text.secondary',
                                                                        '&:hover': {
                                                                            color: 'error.main',
                                                                            backgroundColor: 'transparent'
                                                                        }
                                                                    }}
                                                                >
                                                                    <CloseIcon fontSize="small" />
                                                                </IconButton>
                                                            </Paper>
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                        </Box>
                                    )}

                                    {/* Uploaded files */}
                                    {/* <UploadedFilesList /> */}
                                </Box>
                            )}
                            {/* Preview Dialog */}
                            <Dialog
                                open={openPreview}
                                onClose={handleClosePreview}
                                maxWidth="md"
                                fullWidth
                            >
                                <DialogTitle>{previewFile?.name}</DialogTitle>
                                <DialogContent sx={{ position: 'relative', minHeight: '400px' }}>
                                    {previewFile && (
                                        <>
                                            <IconButton
                                                onClick={handleClosePreview}
                                                sx={{
                                                    position: 'absolute',
                                                    right: 8,
                                                    top: 8,
                                                    color: 'grey.500',
                                                    bgcolor: 'background.paper',
                                                    zIndex: 1,
                                                    boxShadow: 1
                                                }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                            {previewFile.type.startsWith('image/') ? (
                                                <Box sx={{ display: 'flex', justifyContent: 'center', pt: 4 }}>
                                                    <img
                                                        src={previewFile.url}
                                                        alt={previewFile.name}
                                                        style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
                                                    />
                                                </Box>
                                            ) : (
                                                <Box sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    height: '100%',
                                                    textAlign: 'center'
                                                }}>
                                                    <Box sx={{ fontSize: 60, mb: 2 }}>
                                                        {renderFileIcon(previewFile.type)}
                                                    </Box>
                                                    <Typography variant="h6" gutterBottom>
                                                        {previewFile.name}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                                        This file type cannot be previewed. Please download to view.
                                                    </Typography>
                                                    <Button
                                                        variant="contained"
                                                        href={previewFile.url}
                                                        download={previewFile.name}
                                                        startIcon={<CloudDownloadIcon />}
                                                    >
                                                        Download File
                                                    </Button>
                                                </Box>
                                            )}
                                        </>
                                    )}
                                </DialogContent>
                            </Dialog>


                            <Divider sx={{ my: 2 }} />
                            <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                                WATCHERS
                            </Typography>
                            {isManager && (
                                <Button
                                    variant="text"
                                    startIcon={<AddIcon />}
                                    sx={{ color: '#2e86de', textTransform: 'none' }}
                                >
                                    Add watchers
                                </Button>
                            )}
                            <Button
                                variant="text"
                                startIcon={<VisibilityIcon />}
                                sx={{ color: '#2e86de', textTransform: 'none', ml: 2 }}
                            >
                                Watch
                            </Button>
                            {/* <Divider sx={{ my: 2 }} /> */}
                            {/* <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Tooltip title="Time tracking">
                                    <IconButton size="small" sx={{ color: '#888' }}>
                                        <AccessTimeIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Add attachment">
                                    <IconButton size="small" sx={{ color: '#888' }}>
                                        <AttachFileIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Add description">
                                    <IconButton size="small" sx={{ color: '#888' }}>
                                        <DescriptionIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Lock task">
                                    <IconButton size="small" sx={{ color: '#888' }}>
                                        <LockIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete task">
                                    <IconButton size="small" sx={{ color: '#888' }}>
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Box> */}

                        </Paper>
                        {taskApiMessage && (
                            <Typography
                                variant="body2"
                                sx={{
                                    color: taskApiMessage.includes('success') ? 'success.main' : 'error.main',
                                    fontWeight: 600
                                }}
                            >
                                {taskApiMessage}
                            </Typography>
                        )}
                        {isManager && (
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', py: 2, }}>
                                <Button variant="contained" onClick={handleSaveUpdateDetailsButton}>
                                    Save
                                </Button>
                            </Box>
                        )}
                        {!isManager && (
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', py: 2, }}>
                                <Button variant="contained" onClick={handleSendForReviewButton}>
                                    Send For Review
                                </Button>
                            </Box>
                        )}

                    </Box>


                </Box>


            </Box>

            {/* Edit Actual Time Dialog (Modal) */}
            <Dialog open={openEditModal} onClose={handleCloseEditModal} maxWidth="xs" fullWidth>
                <DialogTitle>Edit Actual Time</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', gap: 2, mt: 2, alignItems: 'flex-start' }}>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Hours"
                            type="tel"
                            fullWidth
                            value={actualTimeEdit.hours}
                            onChange={handleActualTimeHoursChange}
                            inputProps={{ maxLength: 3 }}
                        />
                        <TextField
                            margin="dense"
                            label="Minutes"
                            type="tel"
                            fullWidth
                            value={actualTimeEdit.minutes}
                            onChange={handleActualTimeMinutesChange}
                            error={minutesError}
                            helperText={minutesError ? "Minutes should be 0-59" : ""}
                            inputProps={{ maxLength: 2 }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseEditModal}>Cancel</Button>
                    <Button onClick={handleSaveActualTime} variant="contained">Save</Button>
                </DialogActions>
            </Dialog>
            {/* Edit Task Details */}
            <Modal
                open={isEditTaskDetailsOpen}
                onClose={handleEditTaskPopupClose}
                aria-labelledby="edit-task-modal-title"
                aria-describedby="edit-task-modal-description"

                BackdropProps={{
                    style: {
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',

                    },
                }}
            >
                <Box
                    sx={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 800,
                        maxHeight: '80vh',
                        bgcolor: 'background.paper',
                        borderRadius: '8px',
                        boxShadow: (theme) => theme.shadows[5],
                        p: 4,
                        outline: 'none', // Important for accessibility, remove default outline
                    }}
                >
                    {/* Your modal content */}
                    <EditTaskDetails selectedTask={selectedTask} onClose={handleEditTaskPopupClose} />
                </Box>
            </Modal>

            {/* Delete Confirmation Dialog */}
            <Dialog
                open={deleteConfirmOpen}
                onClose={handleCancelDelete}
                aria-labelledby="delete-confirmation-dialog"
            >
                <DialogTitle id="delete-confirmation-dialog">
                    Confirm Delete
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to delete this task? This action cannot be undone.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelDelete} color="primary">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirmDelete}
                        color="error"
                        variant="contained"
                        autoFocus
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity={snackbarSeverity}
                    variant="filled"
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default TaskDetails;